import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import BlogIndex from '../views/BlogIndex.vue'
import BlogView from '../views/BlogView.vue'
import PropertyView from '../views/PropertyView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/blog',
    name: 'BlogIndex',
    component: BlogIndex
  },
  {
    path: '/blog/:slug',
    name: 'BlogView',
    component: BlogView
  },
  {
    path: '/properties/:slug',
    name: 'PropertyView',
    component: PropertyView
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
